import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';
import { Plate } from '../../models/plate';
import { Covid19Batch } from '../../agptesting-newview/model/covid19Batch';
import { BBResponseContainer } from '../../common-services/response-container';
import { timeout, tap, map } from 'rxjs/operators';
import { CommentDTO } from '../../ma-comments-popup/comment-dto';

@Injectable({
  providedIn: 'root'
})
export class AdminSearchService {


  constructor(private httpClient: HttpClient) { }
  ADMIN_SEARCH_API = environment.BB_SAMPLE_PROCESSING_API
  HISTORY_SEARCH_API = environment.BB_MA_DELIVERY_API


  fetchPlate(labId:string, plateID: string){
    let url = this.ADMIN_SEARCH_API+'plate/'+labId+"/"+plateID;
    return this.httpClient.get<Plate>(url);
  }

  fetchPlateByIDandLab(labid:string, plateid: string, platetype: string){
    let url = this.ADMIN_SEARCH_API+'sampleDetailsByPlateId/'+labid+'/'+plateid+'?platetype='+platetype;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as Plate));
  }

  fetchPlateBySample(labid: string, sample_id : string){
    let url = this.ADMIN_SEARCH_API+'sampleDetailsbySampleId/'+labid+"/"+sample_id;
    return this.httpClient.get<Plate>(url);
  }

  fetchPlateByBeadchip(labid: string, beadchipID:string){
    let url = this.ADMIN_SEARCH_API+'beadchipDetailsbyBeadchipId/'+labid+'/'+beadchipID;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as Plate))
  }

  saveUpdatedStatus(labid: string, plateId: string, plateDetails: Plate ){
    let url = this.ADMIN_SEARCH_API + 'plate/'+labid+'/'+plateId
    return this.httpClient.put<Plate>(url, plateDetails);
  }

  saveUpdatedBeadChipStatus(labid: string, plateId: string, beadChipId: string, plateDetails: Plate){
    let url = this.ADMIN_SEARCH_API + 'beadchips'
    let body = {
      labid : labid,
      plateId: plateId,
      beadChipId: beadChipId,
      plateDetails : plateDetails
    }
    return this.httpClient.put<Plate>(url, body);
  }

  commentDetailsbyPlateId(labId : string, plateId: string){
    let url = this.ADMIN_SEARCH_API+'commentDetailsbyPlateId/'+labId+"/"+plateId;
    return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data as Plate)));
  }

  saveSampleData(batch: Covid19Batch, noOfPositivePCRControls: number, noOfNegativePCRControls): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch?noOfPositivePCRControls=1&noOfNegativePCRControls=1";
    return this.httpClient.post<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout), tap({next: event => { }, error: (error: any) => {
        error.url = url;
    }}));
  }

  getBatchForLabAndBatchId(labId: string, fieldName: string , value:string ): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch";
    let requestParam = new HttpParams().set('lab', labId).set('fieldName', fieldName).set('value', value);
    const options = url ? { params: requestParam } : {};
    return this.httpClient.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  saveComment(batchID: string, labId: string, comments: Comment[]): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/comment/"+batchID+"/"+labId;
    return this.httpClient.patch<BBResponseContainer>(url, comments).pipe(timeout(environment.defaultTimeout));
  }

  updateComment(commentDTO:CommentDTO){
    let url = this.ADMIN_SEARCH_API+'updatecomments';
    return this.httpClient.put<BBResponseContainer>(url,commentDTO).pipe(map(result => result.data as string))
  }

  getSampleHistory(labId: string, id: string){
    let url = this.HISTORY_SEARCH_API + 'getSampleHistory/'+labId+"/"+id;
    return this.httpClient.get<any>(url);  
  }

  fetchPlateByPlateIDandLab(labid: string, plateid: string) {
    let url = this.ADMIN_SEARCH_API+'plateDetailsbyPlateID/'+labid+'/'+plateid;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as string))
  }

  getPlateHistory(labId: string, plate_id: string) {
    let url = this.HISTORY_SEARCH_API + 'getPlateHistory/'+labId+"/"+plate_id;
    return this.httpClient.get<any>(url);  
  }


  uploadExternalRedoFile(formData:FormData){
    let url = `${this.ADMIN_SEARCH_API}admin/update/analysisUpdate`;
    return this.httpClient.post<BBResponseContainer>(url,formData).pipe((map(result => result.data as string)))
  }

  getBeadChipsByPlateIDandLab(selectedLabID: string, searchPlateID: string) {
    const url = `${this.ADMIN_SEARCH_API}beadchipsByPlateID/${selectedLabID}/${searchPlateID}`;
    return this.httpClient.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), map(result => result.data as any))
  }

}
